export default {
  appliesToAllReports: 'Platí pre všetky správy',
};
